import { render, staticRenderFns } from "./OrderWhatsButton.vue?vue&type=template&id=44486f93"
import script from "./OrderWhatsButton.vue?vue&type=script&lang=js"
export * from "./OrderWhatsButton.vue?vue&type=script&lang=js"
import style0 from "./OrderWhatsButton.vue?vue&type=style&index=0&id=44486f93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports